import React from 'react';
import { compose, withHandlers, lifecycle, withState, withPropsOnChange } from 'recompose';
import { reduxForm, Field } from 'redux-form';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { allServices } from '../services/_api';
import {
  createReservationService,
  updateReservationService,
  deleteReservationService
} from './_api';
import { get, find, filter } from 'lodash';
import withLoader from '../app/withLoader';
import { TextField } from 'redux-form-material-ui';

const enhance = compose(
  withLoader,
  withState('services', 'setServices', []),
  lifecycle({
    async componentDidMount() {
      const { toggleLoader, setServices } = this.props;
      toggleLoader();
      const resp = await allServices();
      if (resp) {
        setServices(resp.items);
      }
      toggleLoader(false);
    }
  }),
  withHandlers({
    onSubmit: ({
      toggleLoader,
      editServicesDialog,
      setEditServicesDialog,
      item,
      services,
      loadItem
    }) => async values => {
      toggleLoader();
      await Object.keys(values.services).map(async service => {
        const findService = find(services, { id: parseInt(service, 10) });
        const data = {
          reservationId: item.id,
          serviceId: parseInt(service, 10),
          personId: parseInt(editServicesDialog.personId, 10),
          quantity: parseInt(values.services[service], 10),
          price: parseInt(values.services[service], 10) * findService.price
        };
        if (data.quantity > 0) {
          if (find(get(item, 'services', []), { serviceId: parseInt(service, 10) })) {
            await updateReservationService(data);
          } else {
            await createReservationService(data);
          }
        } else {
          await deleteReservationService(data);
        }
        return null;
      });
      await loadItem(item.id);
      setEditServicesDialog({ open: false, title: '' });
      toggleLoader(false);
    }
  }),
  reduxForm({ form: 'editServices' }),
  withPropsOnChange(['item'], ({ item, editServicesDialog, initialize }) => {
    const editServices = [];
    filter(get(item, 'services', []), { personId: parseInt(editServicesDialog.personId, 10) }).map(
      item => {
        editServices[item.serviceId] = item.quantity;
        return null;
      }
    );
    initialize({ services: editServices });
    return {};
  })
);

export default enhance(
  ({ editServicesDialog, setEditServicesDialog, fullScreen, handleSubmit, services }) => (
    <form onSubmit={handleSubmit}>
      <Dialog
        fullScreen={fullScreen}
        open={editServicesDialog.open}
        onClose={() => setEditServicesDialog({ open: false, title: '' })}
        aria-labelledby="responsive-dialog-title"
        style={{
          minWidth: 400,
          width: '80%',
          minHeight: '80vh',
          maxHeight: '80vh'
        }}
        maxWidth="md"
        fullWidth={true}
      >
        <DialogTitle id="responsive-dialog-title">Upravit servisní služby</DialogTitle>
        <DialogContent style={{ minHeight: '500px', overflow: 'hidden' }}>
          <Grid container={true} spacing={16}>
            {services.map(item => (
              <Grid item xs={6} key={item.id}>
                <Field
                  name={`services.${item.id}`}
                  component={TextField}
                  label={item.name}
                  fullWidth
                  type="number"
                />
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            onClick={handleSubmit}
            autoFocus
          >
            Uložit
          </Button>
          <Button
            onClick={() => setEditServicesDialog({ open: false, title: '' })}
            color="secondary"
            variant="contained"
          >
            Zrušit
          </Button>
        </DialogActions>
      </Dialog>
    </form>
  )
);



// WEBPACK FOOTER //
// ./src/modules/reservations/editServicesDialog.js